export function formatRelative(iso: string | null, lang: string): string {
  if (!iso) return '';
  const date = new Date(iso);
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  const isNL = lang.startsWith('nl');
  if (seconds < 60) return isNL ? 'zojuist' : 'just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return isNL ? `${minutes} min geleden` : `${minutes} min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return isNL ? `${hours} uur geleden` : `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days === 1) return isNL ? 'gisteren' : 'yesterday';
  if (days < 7) return isNL ? `${days} dagen geleden` : `${days}d ago`;
  return date.toLocaleDateString(lang);
}
